import React from 'react'
import JsxParser from 'react-jsx-parser/lib/react-jsx-parser.min'
import { helpers } from '@edulastic/common'
import HighlightableStimulus from './Common/HighlightableContent/HighlightableStimulus'

const JsxParserWrapper = ({
  stimulus,
  initialParsedTemplate,
  responseBoxElementType = 'div',
  responseBoxName = '',
  ...restProps
}) => {
  const renderParsedTemplate = (props) => {
    const { updatedStimulusContent } = props || {}
    let transformedTemplate = helpers.transformHighlightedContentToTemplate({
      highlightedContent: updatedStimulusContent,
      responseBoxElementType,
      responseBoxName,
    })
    transformedTemplate = helpers.parseTemplate(
      transformedTemplate || initialParsedTemplate
    )

    return (
      <JsxParser
        key={transformedTemplate}
        jsx={transformedTemplate}
        {...restProps}
      />
    )
  }

  return (
    <HighlightableStimulus stimulus={stimulus}>
      {renderParsedTemplate}
    </HighlightableStimulus>
  )
}

export default JsxParserWrapper
